<template>
  <svg viewBox="0 70 204 90" xmlns="http://www.w3.org/2000/svg">
    <g transform="matrix(1, 0, 0, 1, 52.785683, 57.700005)">
      <path
        d="M38.8,40.7A63.26,63.26,0,0,0,44.9,65C51,76.9,59.5,84.5,66.5,87.5,73.7,84,80.7,78,84.6,71.6H64.7c-5.2-4.4-9.2-11.6-10.2-20h59.2a90.55,90.55,0,0,1-15,33.8,71,71,0,0,1-31.9,24H66.2c-21.1-8.6-32.4-22.1-39.9-37.3-4.8-9.8-9.8-27.5-9.8-51.3H116.6a153.89,153.89,0,0,1-1.3,20H38.8V40.7Z"
        transform="translate(-16.5 -20.8)"
        style="fill: rgb(195, 157, 0)"
      />
    </g>
    <g transform="matrix(1, 0, 0, 1, 25.078918, 52.785156)">
      <line
        style="
          stroke-width: 7px;
          paint-order: fill;
          fill: rgb(186, 218, 85);
          stroke: rgb(195, 157, 0);
        "
        x1="122.188"
        y1="28.909"
        x2="185.191"
        y2="28.909"
        transform="matrix(0.707107, 0.707107, -0.707107, 0.707107, 65.456362, -100.207637)"
      />
      <line
        style="
          stroke-width: 7px;
          paint-order: fill;
          fill: rgb(186, 218, 85);
          stroke: rgb(195, 157, 0);
        "
        x1="121.183"
        y1="69.521"
        x2="184.185"
        y2="69.521"
        transform="matrix(0.707107, -0.707107, 0.707107, 0.707107, -4.438666, 128.326121)"
      />
    </g>
    <g transform="matrix(-1, 0, 0, -1, 178.921082, 151.214844)">
      <line
        style="stroke-width: 7px; stroke: rgb(195, 157, 0)"
        x1="122.188"
        y1="28.909"
        x2="185.191"
        y2="28.909"
        transform="matrix(0.707107, 0.707107, -0.707107, 0.707107, 65.456362, -100.207637)"
      />
      <line
        style="stroke-width: 7px; stroke: rgb(195, 157, 0)"
        x1="121.183"
        y1="69.521"
        x2="184.185"
        y2="69.521"
        transform="matrix(0.707107, -0.707107, 0.707107, 0.707107, -4.438666, 128.326121)"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'logo',
  props: ['light', 'konami'],
};
</script>
